// @ai-generated 2026-08-11T00:00:00Z by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useOfferStartedRun } from '@Hooks/AgenticOrchestrator/useOfferStartedRun';
import { useWorkflowDefinitionStory } from '@Hooks/AgenticOrchestrator/useWorkflowStory';
import { EnumWorkflowStepEffect } from '@Model';
import { FlexColumn, FrameHeader, LoadingFrame } from '@synqo/frontend-component-library';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import classes from './FrameWorkflowMonitor.module.css';
import { WorkflowRunStartModal } from './WorkflowRunStartModal';
import { WorkflowStepList } from './WorkflowStepList';

/**
 * Read-only preview of a workflow definition: what it will do, in the same row shape the run is
 * later watched in. The header action starts a run of it — whatever the workflow asks is confirmed
 * by starting it, so it needs no chat to run in.
 */
export function FrameWorkflowMonitor() {
    const { itemId = '' } = useParams();
    const { view, isLoading, error } = useWorkflowDefinitionStory(itemId);
    const { offerStartedRun } = useOfferStartedRun();
    const [isStartOpen, setIsStartOpen] = useState(false);

    const openStart = useCallback(() => setIsStartOpen(true), []);
    const closeStart = useCallback(() => setIsStartOpen(false), []);

    const showRun = useCallback(() => offerStartedRun(view?.title ?? 'Workflow'), [offerStartedRun, view?.title]);

    if (isLoading) {
        return <LoadingFrame />;
    }

    const writeSteps = view?.steps.filter((step) => step.effect === EnumWorkflowStepEffect.Write).length ?? 0;

    return (
        <FlexColumn gap="none" height="100%" width="100%">
            <FrameHeader label="Workflow-Vorschau" resourceLabel="Workflow-Vorschau" />
            <div className={classes.scroll}>
                <div className={classes.panel}>
                    <div className={classes.header}>
                        <div>
                            <h1 className={classes.title}>{view?.title ?? 'Workflow'}</h1>
                            <p className={classes.subtitle}>{describePreview(view?.steps.length ?? 0, writeSteps)}</p>
                        </div>
                        <button
                            type="button"
                            className={classes.startButton}
                            onClick={openStart}
                            disabled={view === undefined}
                        >
                            Workflow starten
                        </button>
                    </div>

                    {error && <div className={classes.error}>Die Vorschau konnte nicht geladen werden.</div>}
                    {view && <WorkflowStepList steps={view.steps} mode={view.mode} />}
                </div>
            </div>
            {view && (
                <WorkflowRunStartModal
                    isOpen={isStartOpen}
                    onClose={closeStart}
                    workflowDefinitionId={itemId}
                    title={view.title}
                    steps={view.steps}
                    onStarted={showRun}
                />
            )}
        </FlexColumn>
    );
}

function describePreview(stepCount: number, writeSteps: number): string {
    const steps = `Vorschau · ${stepCount} ${stepCount === 1 ? 'Schritt' : 'Schritte'}`;
    if (writeSteps === 0) {
        return `${steps} · ändert keine Daten`;
    }
    return `${steps} · ${writeSteps} ${writeSteps === 1 ? 'Schritt ändert' : 'Schritte ändern'} Daten`;
}
